import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { SharedModule } from '../../shared/shared.module';

import {
  ServiceOrderManagementComponent,
  ServiceOrderManagementListComponent,
  ServiceOrderManagementViewComponent
} from './';

@NgModule({
  declarations: [
    ServiceOrderManagementComponent,
    ServiceOrderManagementListComponent,
    ServiceOrderManagementViewComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    LoadingBarModule,
    SharedModule
  ]
})
export class ServiceOrderManagementModule { }
